export const REF_NAME = 'DOCUMENTTYPE';
export const REF_PATH = 'documenttype';
export const NAME = 'Document type';
